<form [formGroup]="form.group">
  @for (input of form.inputs; track trackInput($index, input)) {
    @switch (input.kind) {
      @case ('DynamicFormInput') {
        <rti-dynamic-form-input
          [input]="$any(input)"
          (remove)="removeInput($event)"
        ></rti-dynamic-form-input>
      }

      @case ('DynamicFormGroup') {
        <rti-dynamic-form-group
          [group]="$any(input)"
          (remove)="removeGroup($event)"
        ></rti-dynamic-form-group>
      }

      @case ('DynamicListInfo') {
        <rti-dynamic-list-info [input]="$any(input)"></rti-dynamic-list-info>
      }

      @case ('DynamicMessage') {
        @if (
          !isHidden(input) &&
          $any(input.config).text &&
          ($any(input.config).text.text || $any(input.config).text.key)
        ) {
          <rt-message
            [innerHTML]="buildText($any(input.config).text)"
            variant="context-information small"
            margin-bottom
          >
          </rt-message>
        }
      }

      @case ('DynamicInfo') {
        @if (isHidden(input)) {
          <div layout-horizontal layout-align-items-center>
            <rt-icon
              name="info-outline"
              size="small"
              colorToken="colorIconLowDefault"
              margin-right-small-x
            ></rt-icon>
            <span text-darkest>{{ buildText($any(input.config).text) }}</span>
          </div>
        }
      }

      @case ('DynamicLabel') {
        @if (
          !isHidden(input) &&
          $any(input.config).text &&
          ($any(input.config).text.text || $any(input.config).text.key)
        ) {
          <rt-heading
            [innerHTML]="buildText($any(input.config).text)"
            variant="heading large"
            margin-bottom
          >
          </rt-heading>
        }
      }

      @case ('DynamicDivider') {
        @if (!isHidden(input)) {
          <rt-divider margin-bottom> </rt-divider>
        }
      }
    }
  }

  @if (additionalGroups) {
    <rti-dynamic-form-additional-groups-dropdown
      [label]="additionalGroups.config.label"
      [options]="additionalGroups.config.options"
      [selected]="state.selectedAdditionalGroupsNames"
      (select)="additionalGroupSelected($event)"
    ></rti-dynamic-form-additional-groups-dropdown>
  }
</form>
